import { Left } from 'fp-ts/Either';
import { type ErrorLeft, errorToLeft } from './errorToLeft';

export function unknownToLeft(e: unknown): Left<ErrorLeft> {
  return errorToLeft(e, {
    fallbackMessage: 'Something went wrong',
    preserveStringMessage: false,
    preserveErrorMessage: false,
    includeRaw: true,
  });
}
